import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import WarningIcon from '@material-ui/icons/WarningRounded';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import findDivisionRelations from '../../../utils/findDivisionRelations';
import * as colors from '../../../styles/colors';
import * as actions from '../../../store/actions';
import getMapProperties from '../../../store/selectors/getMapProperties';

const Warnings = ({ dispatch, divisionlessPropertiesCount, divisionlessUsersCount, history, mapProperties }) => {
  const medPriorities = mapProperties.ids.filter(propertyId => mapProperties.byId[propertyId].markerParams.color === colors.markers.property.MEDIUM_PRIORITY);
  return (divisionlessPropertiesCount > 0 || divisionlessUsersCount > 0) && (
    <>
      <Divider />
      <List subheader={<ListSubheader style={{ backgroundColor: 'white' }}>Warnings</ListSubheader>}>
        {divisionlessPropertiesCount > 0 && (
          <ListItem button onClick={() => history.push('/divisions')}>
            <ListItemIcon>
              <WarningIcon />
            </ListItemIcon>
            <ListItemText secondary={
              divisionlessPropertiesCount === 1
                ? `There is 1 property assigned to no divisions. They are not visible to any officers.`
                : `There are ${divisionlessPropertiesCount} properties assigned to no divisions. They are not visible to any officers.`} 
            />
          </ListItem>
        )}
        {divisionlessUsersCount > 0 && (
          <ListItem button onClick={() => history.push('/divisions')}>
            <ListItemIcon>
              <WarningIcon />
            </ListItemIcon>
            <ListItemText secondary={
              divisionlessUsersCount === 1
                ? `There is 1 user assigned to no divisions. They cannot see any other properties or users.` 
                : `There are ${divisionlessUsersCount} users assigned to no divisions. They cannot see any other properties or users.` 
            }/>
          </ListItem>
        )}
        {medPriorities.length > 0 && (
          <ListItem button onClick={() => dispatch(actions.mapFilter.setMediumPriorityOnly())}>
            <ListItemIcon>
              <WarningIcon />
            </ListItemIcon>
            <ListItemText secondary={
              medPriorities.length === 1
              ? `There is 1 property with overdue patrols. Click to set filter accordingly.`
              : `There are ${medPriorities.length} properties that require activity reports. Click to set filter accordingly.`
            } />
          </ListItem>
        )}
      </List>
    </>
  );
};

const mapStateToProps = state => {
  const mapProperties = getMapProperties(state);
  return {
    mapProperties,
    divisionlessPropertiesCount: Object.values(state.properties.byId)
      .filter(property => !property.isDeleted && Object.keys(findDivisionRelations(property.propertyId).included).length === 0)
      .length,
    divisionlessUsersCount: Object.values(state.users.byId)
      .filter(user => !user.isDeleted && Object.keys(findDivisionRelations(user.userId).included).length === 0)
      .length,
  };
};

export default withRouter(connect(mapStateToProps)(Warnings));